import heroBg from '../images/landing_hero_new.png';
import teamAbout from '../images/team_about.png';
import '../css/textani.css';

export default function landing() {
  return (
    <>
      {/* ── Hero Section ─────────────────────────── */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          minHeight: '88vh',
          display: 'flex',
          alignItems: 'center',
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          overflow: 'hidden',
        }}
      >
        {/* Dark overlay */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(135deg, rgba(13,27,42,0.88) 0%, rgba(13,27,42,0.65) 100%)',
        }} />

        {/* Hero content */}
        <div className="container position-relative text-start text-white" style={{ padding: '80px 40px' }}>
          <p className="section-label animate-fade-up mb-3">FTB Innosphere</p>

          <h1
            className="animate-fade-up delay-1 fw-800 mb-4"
            style={{
              fontSize: 'clamp(2.2rem, 5vw, 3.8rem)',
              fontWeight: 800,
              lineHeight: 1.15,
              maxWidth: '720px',
            }}
          >
            Innovative IT Solutions<br />
            <span style={{ color: '#0dcaf0' }}>&amp; Support</span>
          </h1>

          <p
            className="animate-fade-up delay-2 mb-5"
            style={{
              fontSize: 'clamp(1rem, 1.8vw, 1.2rem)',
              color: '#94a3b8',
              maxWidth: '560px',
              lineHeight: 1.75,
            }}
          >
            We help businesses worldwide resolve IT issues, implement solutions,
            and drive growth through technology expertise.
          </p>

          <div className="animate-fade-up delay-3 d-flex flex-wrap gap-3">
            <a
              href="/service"
              className="btn btn-primary fw-semibold px-4 py-2 rounded-pill shadow"
              style={{ fontSize: '1rem', transition: 'transform 0.2s' }}
              onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
            >
              Explore Services
            </a>
            <a
              href="/contact"
              className="btn btn-outline-light fw-semibold px-4 py-2 rounded-pill"
              style={{ fontSize: '1rem', transition: 'transform 0.2s' }}
              onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* ── Gradient Divider ─────────────────────── */}
      <div style={{
        height: '5px',
        background: 'linear-gradient(90deg, #0d6efd, #0dcaf0, #0d6efd)',
      }} />

      {/* ── About / Intro Section ───────────────── */}
      <div className="container-fluid py-6" style={{ padding: '80px 40px', background: 'var(--ftb-bg-alt)', transition: 'var(--transition)' }}>

        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 text-start">
              <p className="section-label">Who We Are</p>
              <h2 className="section-title mt-2 mb-4">Welcome to FTB Innosphere</h2>
              <p style={{ color: 'var(--ftb-text-muted)', lineHeight: 1.8, fontSize: '1.05rem' }}>
                We are a leading provider of premier IT services for businesses worldwide.
                We specialise in resolving issues, implementing solutions, creating comprehensive
                documentation, and developing new reports based on existing system features.
              </p>
              <p style={{ color: 'var(--ftb-text-muted)', lineHeight: 1.8, fontSize: '1.05rem' }} className="mt-3">
                At FTB Innosphere, our team of highly skilled professionals ensures your systems
                perform at their best — whether you need issue resolution, implementation guidance,
                documentation, or customised report development.
              </p>

              <a
                href="/service"
                className="btn btn-primary rounded-pill px-4 py-2 mt-4 fw-semibold"
                style={{ transition: 'transform 0.2s' }}
                onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
              >
                Our Services →
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src={teamAbout}
                alt="FTB Innosphere team collaboration"
                className="img-fluid rounded-4 shadow-lg"
                style={{ width: '100%', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ── Key Stats Strip ──────────────────────── */}
      <div style={{ background: 'linear-gradient(90deg, #0d6efd, #0dcaf0)', padding: '40px 20px' }}>
        <div className="container">
          <div className="row text-white text-center g-4">
            {[
              { value: '100+', label: 'End Users Impacted' },
              { value: 'High Volume', label: 'Daily Data Processing' },
              { value: 'Multiple', label: 'Business Lines Supported' },
              { value: '24/7', label: 'Production Support' },
            ].map((stat, i) => (
              <div className="col-6 col-md-3" key={i}>
                <div style={{ fontSize: 'clamp(1.8rem, 4vw, 2.6rem)', fontWeight: 800, lineHeight: 1 }}>
                  {stat.value}
                </div>
                <div style={{ fontSize: '0.9rem', opacity: 0.85, marginTop: '6px' }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── About FTB Innosphere ─────────────────── */}
      <div className="container-fluid py-5" style={{ padding: '70px 40px', background: 'var(--ftb-bg-page)', transition: 'var(--transition)' }}>

        <div className="container text-center">
          <p className="section-label">Our Mission</p>
          <h2 className="section-title mt-2 mb-4">About FTB Innosphere</h2>
          <div className="row g-4 mt-2">
            {[
              { icon: '🎯', title: 'Results-focused', text: 'We develop results for the future using new emerging and established technologies.' },
              { icon: '🤝', title: 'Dedicated Team', text: 'Our team delivers solutions to client problems with dedication and expertise.' },
              { icon: '🚀', title: 'Cutting-Edge', text: 'We stay abreast of the latest technologies and collaboration tools.' },
            ].map((item, i) => (
              <div className="col-md-4" key={i}>
                <div className="ftb-service-card p-4 h-100 text-center">
                  <div className="ftb-card-accent" />
                  <div style={{ fontSize: '2rem', margin: '20px 0 12px' }}>{item.icon}</div>
                  <h5 style={{ fontWeight: 700, color: 'var(--ftb-text)' }}>{item.title}</h5>
                  <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.95rem', lineHeight: 1.7 }}>{item.text}</p>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Call-to-action Banner ────────────────── */}
      <div
        style={{
          background: 'var(--ftb-bg-card)',
          padding: '60px 40px',
          textAlign: 'center',
          transition: 'var(--transition)',
          boxShadow: 'var(--ftb-shadow-lg)'
        }}
      >

        <div className="container">
          <p className="section-label">Ready to get started?</p>
          <h2 style={{ color: '#fff', fontWeight: 700, fontSize: 'clamp(1.6rem, 3vw, 2.2rem)', margin: '16px 0' }}>
            Let's build something great together
          </h2>
          <p style={{ color: '#94a3b8', marginBottom: '32px', fontSize: '1.05rem' }}>
            "WE ARE HERE TO PUT A DENT IN THE UNIVERSE — OTHERWISE WHY ELSE EVEN BE HERE."
          </p>
          <a
            href="/contact"
            className="btn btn-primary fw-semibold px-5 py-3 rounded-pill shadow"
            style={{ fontSize: '1.05rem', transition: 'transform 0.2s' }}
            onMouseOver={e => e.currentTarget.style.transform = 'translateY(-3px)'}
            onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Get in Touch
          </a>
        </div>
      </div>
    </>
  );
}
